<div class="row mt-2 px-4" #containerRef>
    <div class="col-12">
        <h6 style="color: #126db3;margin-left: 20px;">
            {{"action_plan.statistics.stages" | translate}}
        </h6>
    </div>
    <div class="col-12 " style="padding: 0 0 15px 0;   background: -moz-linear-gradient(top,  whitesmoke 296px, white 22px); /* FF3.6+ */
    background: -webkit-gradient(linear, left top, left bottom, color-stop(296px,whitesmoke), color-stop(22px,white)); /* Chrome,Safari4+ */
    background: -webkit-linear-gradient(top,  whitesmoke 296px,white 22px);">
        <ngx-charts-bar-horizontal [results]="etapas" [scheme]="colorScheme" [xAxisTickFormatting]="axisFormat"
            [view]="[containerRef.offsetWidth - 35, 320]" [xAxisLabel]="'Products'" [legendTitle]="'Product Sale Chart'"
            [yAxisLabel]="'Sale'" [legend]="false" [legendPosition]="'below'" [showXAxisLabel]="false"
            [showYAxisLabel]="false" [xAxis]="true" [yAxis]="true" [gradient]="false" [barPadding]="15"
            [trimXAxisTicks]="false" [trimYAxisTicks]="false">
        </ngx-charts-bar-horizontal>
    </div>
    <hr style="    width: 100%;
    position: relative;
    top: -55px;
    background: #d3d3d3">
    <div class="col-12 d-flex justify-content-end" style="top:-30px">

        <h5 class="text-secondary text-right" style="font-size: 14px;">
            {{"action_plan.statistics.quantity" | translate}}
        </h5>
    </div>
</div>